// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9.55 2.03C10.13 1.7 10.85 1.74 11.39 2.11L13.74 3.73C14.22 4.05 14.5 4.59 14.5 5.17L14.5 8.47C14.5 9.11 14.16 9.69 13.6 10L6.45 13.97C5.87 14.3 5.15 14.26 4.61 13.89L2.26 12.27C1.78 11.95 1.5 11.41 1.5 10.83L1.5 7.53C1.5 6.89 1.84 6.31 2.4 6Z',
  'M1.74 6.64L5.5 9.25L14.3 4.36',
  'M5.5 9.25L5.51 14.19',
];
